export enum OnboardingStatus {
  INITIAL = 'INITIAL',
  IN_PROGRESS = 'IN_PROGRESS',
  COMPLETED = 'COMPLETED',
}

export interface Onboarding {
  hideDeviceTrackBlock: boolean;
}
